export enum PrivacyPolicyAcknowledgment {
  NONE = 'none',
  SHOW = 'show',
  ENFORCE = 'enforce',
}
